import { useMemo, useState, useRef } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import "./CartItem.css";
import {
  decreaseItemThroughScanner,
  deleteItemThroughScanner,
  deleteValidationItem,
  editCart,
  validateItemManual,
} from "../../../../../config/Services";
import { useMutation } from "@tanstack/react-query";
import { useSnackbar } from "../../../product/hooks/SnackbarProvider";
import { useAddToCart } from "../../../product/hooks/useAddToCart";
import Scale from "assets/images/scale.png";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { sortItems } from "../../../product/all-products/utils/cartUtils";
import { Checkbox, CircularProgress } from "@mui/material";
import { setOdsCart } from "../../../product/all-products/redux/Actions/paginationActions";
import { useDispatch } from "react-redux";
import { getStoreCurrencySymbol } from "../../../../../utils/currency";

const CartItem = ({ item, cartId }) => {
  const showSnackbar = useSnackbar();
  const { addItemDirect } = useAddToCart();
  const [cartQuantity, setCartquantity] = useState("");
  const locId = localStorage.getItem("locId");
  const dispatch = useDispatch();
  const editStartTimeRef = useRef(null);
  const isProfilerOn = localStorage.getItem("profilerSwitch") === "true";
const [updateResponseCartTime, setUpdateResponseCartTime] = useState(() => {
  const item = localStorage.getItem("updateCartResponseTime");
  return item ? JSON.parse(item) : [];
});
  const storedDetails = localStorage.getItem("retailUserDetails");
    let retailUserDetails = null;
  if (storedDetails) {
    try {
      retailUserDetails = JSON.parse(storedDetails);
    } catch (error) {}
  }
  const uidx = retailUserDetails?.uidx;

  const payload = {
    cartId: cartId,
    sellingPrice: item?.sellingPrice,
    gtin: item?.gtin,
    locationId: locId,
    mrp: item?.mrp,
    inventoryChecks: "NO",
    batchNo: item?.batchNo,
    purchasePrice: item?.purchasePrice ?? "",
    quantityBySpecs: item?.quantityBySpecs,
    sellingUnit: item?.sellingUnit,
  };
  const addItemThroughScannerPayload = {
    cartId: cartId,
    sellingPrice: item?.sellingPrice,
    gtin: item?.gtin,
    locationId: locId,
    mrp: item?.mrp,
    inventoryChecks: "NO",
    batchNo: item?.batchNo,
    purchasePrice: item?.purchasePrice ?? "",
    quantityBySpecs: item?.quantityBySpecs,
    sellingUnit: item?.sellingUnit,
    variantName: item?.productName,
    vendorId: item?.vendorId,
    packagingType: item?.packagingType,
    brandName: item?.brand,
  };
  const manualValidate = useMutation({
    mutationFn: (payload) => validateItemManual(payload),
    onSuccess: (res) => {
      if (!!res?.data?.data?.es) {
        showSnackbar(res?.data?.data?.message, "error");
        return;
      }
      const newCartItems = sortItems(res?.data?.data?.data?.cartProducts);
      dispatch(setOdsCart(newCartItems));
      showSnackbar("Item edited successfully", "success");
    },
    onError: (error) => {
      showSnackbar(error?.response?.data?.message || error?.message, "error");
    },
  });

  const editItemMutation = useMutation({
    mutationFn: (payload) => editCart(payload),
    onSuccess: (res) => {
      if (isProfilerOn) {
        const end = new Date().getTime();

        const timeTaken = end - (editStartTimeRef.current || end);

        const updatedCartUpdateResponseTimes = [
          ...updateResponseCartTime,
          { time: end, responseTime: timeTaken },
        ];
        localStorage.setItem(
          "updateCartResponseTime",
          JSON.stringify(updatedCartUpdateResponseTimes)
        );
        setUpdateResponseCartTime(updatedCartUpdateResponseTimes);
      }
      const newCartItems = sortItems(res?.data?.data?.data?.cartProducts);
      dispatch(setOdsCart(newCartItems));
      showSnackbar("Item edited successfully", "success");
    },
    onError: (error) => {
      showSnackbar(error?.response?.data?.message || error?.message, "error");
    },
  });

  const decreaseItemMutation = useMutation({
    mutationFn: (payload) => decreaseItemThroughScanner(payload),
    onSuccess: (res) => {
      const newCartItems = sortItems(res?.data?.data?.cartProducts);
      dispatch(setOdsCart(newCartItems));
      showSnackbar(`Item quantity decreased`, "success");
    },
    onError: (error) => {
      showSnackbar(error?.response?.data?.message || error?.message, "error");
    },
  });

  const [increaseLoading, setIncreaseLoading] = useState(false);

  const deleteItemMutation = useMutation({
    mutationFn: (payload) => deleteValidationItem(payload),
    onSuccess: (res) => {
      if (!!res?.data?.data?.es) {
        throw new Error(res?.data?.data?.message);
      }
      const newCartItems = sortItems(res?.data?.data?.data?.cartProducts);
      dispatch(setOdsCart(newCartItems));
      showSnackbar("Item deleted successfully", "success");
    },
    onError: (error) => {
      showSnackbar(error?.response?.data?.message || error?.message, "error");
    },
  });

  useMemo(() => {
    if (item?.sellingUnit === "nos" || item?.sellingUnit === "no") setCartquantity(item?.quantity);
    else
      setCartquantity(
        (item?.quantityBySpecs && parseFloat(item?.quantityBySpecs).toFixed(2)) || item?.quantity
      );
  }, [item]);

  const isWeighingBarcode = useMemo(() => !!item?.quantityBySpecs, [item]);

  const handleSubmit = (e) => {
    e.preventDefault();
    editStartTimeRef.current = new Date().getTime();

    const editPayload = {
      cartId: payload.cartId,
      cartProductId: payload.cartProductId,
      qty: isWeighingBarcode ? 1 : cartQuantity,
      quantityBySpecs: isWeighingBarcode ? cartQuantity : null,
      updatedBy: uidx,
    };
    editItemMutation.mutate(editPayload);
  };

  const handleDelete = () => {
    const deletePayload = { cartId, cartProductId: item?.cartProductId };
    deleteItemMutation.mutate(deletePayload);
  };

  const handleDecrease = () => {
    const decreasePayload = { ...payload };
    decreaseItemMutation.mutate(decreasePayload);
  };

  const handleIncrease = () => {
    setIncreaseLoading(true);
    addItemDirect(addItemThroughScannerPayload, [], {
      onBeforeError: () => setIncreaseLoading(false),
      onSuccess: (cartData) => {
        const newCartItems = sortItems(cartData?.cartProducts);
        dispatch(setOdsCart(newCartItems));
        showSnackbar("Item quantity increased", "success");
        setIncreaseLoading(false);
      },
      onError: (errMsg) => {
        showSnackbar(errMsg, "error");
        setIncreaseLoading(false);
      },
    });
  };

  const handleManualValidate = (isValidated) => {
    const validatePayload = {
      cartId,
      cartProductId: item?.cartProductId,
      isManualValidate: !isValidated,
    };
    manualValidate.mutate(validatePayload);
  };

  const isLoading =
    editItemMutation?.isLoading ||
    decreaseItemMutation?.isLoading ||
    increaseLoading ||
    deleteItemMutation?.isLoading;

  const renderForm = () => (
    <form className="validate-form" onSubmit={handleSubmit} name="validate-form">
      <input
        className="cartRowItem qty-input"
        step={isWeighingBarcode ? "any" : "1"}
        type="number"
        value={cartQuantity}
        onChange={(e) => setCartquantity(e.target.value)}
      />
    </form>
  );

  const renderValidationQuantity = () => {
    if (cartQuantity > 1) {
      const remainingCount = isWeighingBarcode
        ? cartQuantity - item?.validatedQuantityBySpecs
        : cartQuantity - item?.validatedQuantity;
      return (
        <div className="items-remaining-box">
          <div className="items-remaining-count">{remainingCount.toFixed(2)}</div>
          <div className="items-remaining-label">remaining</div>
        </div>
      );
    }
  };

  return (
    <div className="validate-cart-item-container">
      <div className={`validate-cart-item-box ${item?.isValidated && `validated-cart-item`}`}>
        <Checkbox
          checked={item?.isValidated}
          onChange={() => handleManualValidate(item?.isValidated)}
        />
        <div className="validate-cart-item-middle-box">
          <div className="validate-cart-item-name">
            <div>{`${item?.productName} (${getStoreCurrencySymbol()}${item?.mrp})`}</div>
            <div>
              {isLoading && (
                <CircularProgress
                  className="validate-cart-item-loader"
                  sx={{ display: "flex" }}
                  size={23}
                />
              )}
            </div>
          </div>
          <div className="validate-cart-item-count-container">
            {isWeighingBarcode ? (
              <div className="validate-weighing-item-count-box">
                <img src={Scale} alt="leaf-icon" className="leaf-icon" />
                {renderForm()}
                <p>{item?.sellingUnit}</p>
              </div>
            ) : (
              <div className="validate-cart-item-count-box">
                <div className="validate-cart-item-count-action" onClick={handleDecrease}>
                  -
                </div>
                {renderForm()}
                <div className="validate-cart-item-count-action" onClick={handleIncrease}>
                  +
                </div>
              </div>
            )}
            {renderValidationQuantity()}
          </div>
        </div>
        <div className="validate-cart-item-right-box">
          {/* {item?.isValidated && (
          <div className="check-icon">
            <CheckCircleIcon />
          </div>
        )} */}
          <div>{getStoreCurrencySymbol()}{item?.subTotal.toFixed(2)}</div>
        </div>
      </div>
      <div className="validate-cart-item-left-box" onClick={handleDelete}>
        <DeleteIcon />
      </div>
    </div>
  );
};

export default CartItem;
